import type { RootState } from '@/root-store';
import {
  createUploadSlice,
  createUploadSliceUtils,
} from '@/shared/store/doc-uploader/create-upload-slice';

import { carAPI } from '../api';
import { CarDocType } from '../model';

import { getCurrentCarId, getUploadedDocsForCurrentCar } from './selectors';

const carUploadNamespace = 'carDocUpload';

const carUploadSlice = createUploadSlice<CarDocType>('sts', carUploadNamespace);

const { selectors: carUploadSelectors, asyncActions: carUploadAsyncActions } =
  createUploadSliceUtils({
    namespace: carUploadNamespace,
    eventTrackingType: 'car',
    actionSetBusy: carUploadSlice.actions.setPending,
    selectHolderId: getCurrentCarId,
    selectUploadedDocs: getUploadedDocsForCurrentCar,
    uploadFile: carAPI.uploadFile,
    getSliceState: (state: RootState) => state[carUploadNamespace],
  });

export { carUploadSlice, carUploadSelectors, carUploadAsyncActions, carUploadNamespace };
